<template>
  <div style="width:100%">
    <v-alert dismissible v-if="errors" type="error">{{errorMessage}}</v-alert>
    <v-breadcrumbs item-text="text" :items="breadcrumbs"></v-breadcrumbs>
    <v-row>
      <v-col cols="3">
        Patient Detials
        <v-autocomplete
          col
          dense
          class="green"
          v-model="model"
          :items="pitems"
          :loading="isLoading"
          :search-input.sync="search"
          color="white"
          hide-no-data
          hide-selected
          item-text="Description"
          item-value="API"
          label="Patient ID, Names or Phone"
          placeholder="Start typing to Search"
          prepend-icon="mdi-database-search"
          return-object
        ></v-autocomplete>
        <v-divider></v-divider>
        <v-expand-transition>
          <v-list v-if="model" class="lighten-3">
            <v-list-item v-for="(field, i) in fields" :key="i" v-show="field.key !='Description'">
              <v-list-item-content>
                <v-list-item-title v-text="field.value"></v-list-item-title>
                <v-list-item-subtitle v-text="field.key"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expand-transition>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!model" color="darken-3" @click="model = null">
            Clear
            <v-icon right>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-actions>
      </v-col>
      <v-col cols="9">
        <v-row>
          <v-col cols="4">
            Select Item
            <v-autocomplete
              :items="investigations"
              color="white"
              item-text="name"
              label="Investigation Item"
              @change="updateUnitPrice"
              cols="3"
              sm="6"
              solo
              chips
              return-object
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            Referral Doctors
            <v-select item-text="dr_name" :items="doctors" label="Refer Doctors" solo></v-select>
          </v-col>
        </v-row>
        <div class="invoice-box">
          <table cellpadding="0" cellspacing="0" dense>
            <tr class="heading">
              <td width="35%">Item</td>
              <td width="30%">Eye</td>
              <td width="10%">Unit Cost</td>
              <td width="10%">Price</td>
              <td width="10%">Disc%</td>
              <td width></td>
            </tr>
            <tr class="item" v-for="(item, index) in items" :key="index">
              <td>{{item.description}}</td>
              <td>
                <v-radio-group
                  row
                  v-if="item.eyeType==2"
                  v-model="item.eye_type"
                  v-on:change="updateQty(item.eye_type,index)"
                >
                  <v-radio label="Left" value="Left" small></v-radio>
                  <v-radio label="Right" value="Right" small></v-radio>
                  <v-radio label="Both" value="Both"></v-radio>
                </v-radio-group>
              </td>
              <td>
                <!-- <input type="number" class="text-right" v-model="" /> -->
                {{item.price | currency}}
              </td>
              <td class="text-right">{{ item.price * item.quantity | currency }}</td>
              <td>
                <input type="number" class="text-right" v-model="item.discount" />
              </td>
              <td>
                <button @click="removeItem(index)">
                  <v-icon color="red" small>mdi-minus-circle</v-icon>
                </button>
              </td>
            </tr>

            <tr>
              <td></td>
              <td class="text-right" colspan="2">Total :</td>
              <td class="text-right">{{ total | currency }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Discount :</td>
              <td class="text-right">{{ discountTotal | currency }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Payable :</td>
              <td class="text-right">{{ payableAmount | currency }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Received :</td>
              <td>
                <input type="number" class="text-right" v-model="invoice_receivedAmount" />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Due :</td>
              <td class="text-right">{{ dueAmount | currency }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-right" colspan="2">Payment Method :</td>
              <td colspan="3">
                <v-col>
                  <v-select item-text="name" :items="paymentMethods" label="Payment Method" solo></v-select>
                </v-col>
              </td>
            </tr>
          </table>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<style>
.v-list-item__content {
  padding: 0px;
}
.v-input--selection-controls {
  margin-top: 0px;
}
.item-select-box {
  widows: 100%;
  padding: 0;
}
.invoice-mini-box {
  max-width: 200px;
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;
}
.invoice-box {
  max-width: 1000px;
  padding: 30px;
  border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #555;
}

.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
}

.invoice-box table tr td:nth-child(n + 2) {
  text-align: center;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  padding-bottom: 40px;
}

.invoice-box table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.item input {
  padding-left: 5px;
}

.invoice-box table tr.item td:first-child input {
  margin-left: -5px;
  width: 100%;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

.invoice-box input[type="number"] {
  width: 60px;
}

@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}

/** RTL **/
.rtl {
  direction: rtl;
  font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
    sans-serif;
}

.rtl table {
  text-align: right;
}

.rtl table tr td:nth-child(2) {
  text-align: left;
}
</style>
<script>
import axios from "axios";
export default {
  data() {
    return {
      items: [],
      paymentMethods: ["Cash", "Bkash", "Card"],
      eyeType: ["Left Eye", "Right Eye", "Both Eye"],
      investigations: [],
      doctors: [],
      invoice_discount: 20,
      row: null,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoices",
          disabled: false,
          href: "/invoices",
        },
        {
          text: "Create Invoice",
          disabled: true,
          href: "",
        },
      ],
      invoice_data: [
        {
          item_name: null,
          eye_type: [],
          unit_price: null,
          qty: null,
          discount: null,
          subtotal: null,
        },
      ],
      radioGroup: 1,
      errors: false,
      errorMessage: [],

      isLoading: false,
      search: null,
      model: [],
      descriptionLimit: 60,
      entries: [],
      invoice_receivedAmount: 0,
      patient_id: null,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.search = this.$route.params.id;
    this.patient_id = this.$route.params.id;
    // this.model.push(this.$route.params.id);
    axios
      .get("http://diqcare-hms-api.local/api/payment-methods")
      .then((response) => {
        this.paymentMethods = response.data.data;
      })
      .catch((e) => {
        this.errors = true;
        this.errorMessage = e;
      });
    axios
      .get("http://diqcare-hms-api.local/api/investigations")
      .then((response) => {
        this.investigations = response.data.data;
      })
      .catch((e) => {
        this.errors = true;
        this.errorMessage = e;
      });
    axios
      .get("http://diqcare-hms-api.local/api/doctors")
      .then((response) => {
        this.doctors = response.data.data;
      })
      .catch((e) => {
        this.errors = true;
        this.errorMessage = e;
      });
  },
  methods: {
    updateUnitPrice(value) {
      // console.log(value);
      // console.log(value.name);
      // console.log(typeof value);
      // console.log(value.one_eye_charge);

      if (typeof value === "object") {
        var index = this.items.findIndex((x) => x.description == value.name);
        // console.warn(index);
        if (index === -1) {
          this.items.push({
            description: value.name,
            quantity: 1,
            discount: this.invoice_discount,
            price: value.one_eye_charge,
            eyeType: value.inv_type,
          });
        }
      }
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    updateQty(value, index) {
      if (value == "Both") {
        this.items[index].quantity = 2;
      } else {
        this.items[index].quantity = 1;
      }
    },
  },
  computed: {
    total() {
      return this.items.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
    },
    discountTotal() {
      return this.items.reduce(
        (acc, item) => acc + (item.price * item.quantity * item.discount) / 100,
        0
      );
    },
    payableAmount() {
      var kk = this;
      kk.invoice_receivedAmount = this.total - this.discountTotal;
      return this.total - this.discountTotal;
    },
    dueAmount() {
      return this.payableAmount - this.invoice_receivedAmount;
    },
    pitems() {
      return this.entries.map((entry) => {
        const Description =
          entry.Description.length > this.descriptionLimit
            ? entry.Description.slice(0, this.descriptionLimit) + "..."
            : entry.Description;

        return Object.assign({}, entry, { Description });
      });
    },
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        this.invoice_discount =
          key == "Investigation Discount%" && this.model[key] != 0
            ? this.model[key]
            : this.invoice_discount;
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },
  },
  filters: {
    currency(value) {
      return value.toFixed(2);
    },
  },
  watch: {
    search(val) {
      // Items have already been loaded
      if (this.pitems.length > 0) return;
      // console.log(val);
      // Items have already been requested
      if (this.isLoading) return true;

      this.isLoading = true;

      // Lazily load input items
      fetch(
        "http://diqcare-hms-api.local/api/patient-search?patient_data=" + val
      )
        .then((res) => res.json())
        .then((res) => {
          const { count, entries } = res;
          this.count = count;
          this.entries = entries;
          if (this.$route.params.id) {
            this.model = entries[0];
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>